import {
  ChangeEvent,
  Dispatch,
  MouseEvent,
  SetStateAction,
  useCallback,
  useState,
} from 'react';

interface UseActionsParams {
  setIsCheckboxChecked: Dispatch<SetStateAction<boolean>>;
  handleToggleMarketingChecked: (checked: boolean) => void;
}

export const useActions = ({
  setIsCheckboxChecked,
  handleToggleMarketingChecked,
}: UseActionsParams) => {
  //#region [---- [HOOKS] ----]
  const [isMarketingExpanded, setIsMarketingExpanded] =
    useState<boolean>(false);
  //#endregion

  //#region [---- [LOGIC] ----]
  const handleToggleMarketingExpanded = useCallback(
    (event: MouseEvent<HTMLSpanElement>) => {
      // Prevent the surrounding label from toggling the checkbox
      event.preventDefault();
      event.stopPropagation();
      setIsMarketingExpanded(prev => !prev);
    },
    [],
  );

  const handleMarketingChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      handleToggleMarketingChecked(event.target.checked);
    },
    [handleToggleMarketingChecked],
  );

  const handleCheckboxChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setIsCheckboxChecked(event.target.checked);
    },
    [setIsCheckboxChecked],
  );
  //#endregion

  return {
    isMarketingExpanded,
    handleToggleMarketingExpanded,
    handleMarketingChange,
    handleCheckboxChange,
  };
};
